// src/components/AdminPanel/AdminSummary.js
import React, { useState, useEffect } from "react";
import { adminApi } from "../../services/adminApi";

function AdminSummary({ adminToken, tabName }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    if (!adminToken) return;
    fetchSummary();
    // eslint-disable-next-line
  }, [adminToken]);

  async function fetchSummary() {
    setLoading(true);
    setError("");
    try {
      const data = await adminApi.getSummary(adminToken);
      setSummary(data);
    } catch (err) {
      setError(err.message || "Error fetching summary");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <h3 style={{ textAlign: "center" }}>{tabName}</h3>
      {loading && <p>Loading summary...</p>}
      {error && <p style={{ color: "red" }}>{error}</p>}
      {summary && (
        <table className="admin-table" style={{ marginTop: "1rem" }}>
          <thead>
            <tr>
              <th>Stat</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Total Users</td>
              <td>{summary.total_users}</td>
            </tr>
            <tr>
              <td>Total Venues</td>
              <td>{summary.total_venues}</td>
            </tr>
            <tr>
              <td>Gatherings Last Week</td>
              <td>{summary.total_gatherings_last_week}</td>
            </tr>
            <tr>
              <td>Gatherings This Week</td>
              <td>{summary.total_gatherings_this_week}</td>
            </tr>
            <tr>
              <td>Gatherings Next Week</td>
              <td>{summary.total_gatherings_next_week}</td>
            </tr>
            <tr>
              <td>Matched Users Last Week</td>
              <td>{summary.matched_users_last_week}</td>
            </tr>
            <tr>
              <td>Unmatched Users Last Week</td>
              <td>{summary.unmatched_users_last_week}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}

export default AdminSummary;
